import React, { FC } from "react";
import { Button, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useCreate } from "@refinedev/core";
import { RcFile } from "antd/lib/upload";
import { v4 as uuid } from "uuid";

import { errorNotification, successNotification } from "../../helpers";
import { EFileTypes } from "../App-Image-Uploader/app-image-uploader.component";

interface MassImageUploaderProps {
  serviceType: EFileTypes;
  type:
    | "NEWS"
    | "MATCH"
    | "TEAM"
    | "PARTNERS"
    | "STADIUM"
    | "BROADCAST"
    | "DOCUMENTS"
    | "STAFF"
    | "MEDICINE";
  entityId: string;
  onUpload: (url: string) => void;
  canUpload: () => boolean;
  maxFileSizeMB?: number;
}

export const MassImageUploader: FC<MassImageUploaderProps> = ({
  serviceType,
  type,
  entityId,
  onUpload,
  canUpload,
  maxFileSizeMB = 5,
}) => {
  const { mutate } = useCreate();

  const beforeUpload = (file: RcFile) => {
    if (!canUpload()) {
      message.error("Достигнут лимит изображений");
      return Upload.LIST_IGNORE;
    }
    const fileSizeInMB = file.size / 1024 / 1024;
    if (fileSizeInMB > maxFileSizeMB) {
      message.error(`Размер файла не должен превышать ${maxFileSizeMB} MB`);
      return Upload.LIST_IGNORE;
    }

    mutate({
      dataProviderName: "uploadDataProvider",
      values: {
        entityId: `${entityId}/${uuid()}`,
        serviceType,
        blob: file,
        type,
      },
      ...errorNotification({}),
      ...successNotification({
        successData: { message: "Файл успешно загружен", type: "success" },
        callback: (data: { s3id: string }) => {
          onUpload(data.s3id);
        },
      }),
      resource: "",
    });

    return Upload.LIST_IGNORE;
  };

  return (
    <Upload
      multiple
      showUploadList={false}
      accept=".jpg,.jpeg,.png,.webp,.bmp,.wbmp"
      beforeUpload={beforeUpload}
    >
      <Button icon={<UploadOutlined />}>Массовая загрузка</Button>
    </Upload>
  );
};
